<script setup>
import {computed, ref, watch} from 'vue'
import {useCollectionFiltersStore} from '@/stores/collectionFilters'
import {useItemDataStore} from '@/stores/itemData'

const props = defineProps({
    contentId: Number,
    item: Object
})

const collectionFiltersStore = useCollectionFiltersStore()
const itemDataStore = useItemDataStore()

const field = ref(null)

watch(
    () => props.item.fieldId,
    async (newId, oldId) => {
        if (oldId !== undefined && newId !== oldId) {
            props.item.operator = ""
        }

        if (!newId) {
            field.value = null
            return
        }

        field.value = await itemDataStore.get({
            tableName: 'modulestructure',
            id: newId
        })
    },
    {immediate: true}
)

const fieldType = computed(() => {
    if (props.item.fieldId === null) return 'collection'
    return field.value?.type
})

const typeOptions = computed(() => {
    if (!fieldType.value && props.item.fieldId !== null) return []

    const options = collectionFiltersStore.typesOptions(fieldType.value, props.item.fieldId)
    return options || []
})
</script>

<template>
    <select
        v-if="typeOptions && typeOptions.length > 0"
        v-model="item.operator"
        class="form-select form-select-sm d-inline-block w-auto"
    >
        <option selected disabled value="">Select&hellip;</option>
        <option v-for="option in typeOptions" :key="option.value" :value="option.value">
            {{ option.text }}
        </option>
    </select>
</template>